import defaultAttributes from '../defaultAttributes';

const ChevronUp = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '18 15 12 9 6 15' }]],
];

export default ChevronUp;
